/**
 * Helpers for factory-imported product listings (CargoPool / sell-new-products).
 */

export const FACTORY_LISTING_TYPE = 'sell-new-products';

/**
 * @param {Object} publicData listing.attributes.publicData
 * @returns {boolean}
 */
export const isFactoryProductListing = publicData =>
  publicData?.listingType === FACTORY_LISTING_TYPE ||
  !!publicData?.mongoProductId ||
  (Array.isArray(publicData?.priceTiers) && publicData.priceTiers.length > 0);

/**
 * Effective MOQ: explicit moq, else lowest price tier minQty.
 * @param {Object} publicData
 * @returns {number|null}
 */
export const getEffectiveMoq = publicData => {
  if (!publicData) return null;
  if (typeof publicData.moq === 'number' && publicData.moq > 0) {
    return publicData.moq;
  }
  const tiers = Array.isArray(publicData.priceTiers) ? publicData.priceTiers : [];
  if (tiers.length === 0) return null;
  const mins = tiers.map(t => Number(t.minQty)).filter(n => Number.isFinite(n) && n > 0);
  if (mins.length === 0) return null;
  return Math.min(...mins);
};

/**
 * @param {number|null} moq
 * @param {string} [unit]
 * @returns {string|null}
 */
export const formatMoqLabel = (moq, unit = 'pcs') => {
  if (moq == null) return null;
  return `${Number(moq).toLocaleString()} ${unit || 'pcs'}`;
};

/**
 * Resolve unit price for a requested quantity from tiers (highest matching minQty).
 * @param {Array<{minQty:number, price:number}>} priceTiers
 * @param {number} quantity
 * @returns {number|null}
 */
export const getTierPriceForQuantity = (priceTiers, quantity) => {
  const qty = Number(quantity);
  if (!Number.isFinite(qty) || qty <= 0 || !Array.isArray(priceTiers) || priceTiers.length === 0) {
    return null;
  }
  const sorted = priceTiers
    .slice()
    .filter(t => Number.isFinite(Number(t.minQty)))
    .sort((a, b) => Number(a.minQty) - Number(b.minQty));
  let match = sorted[0];
  sorted.forEach(t => {
    if (qty >= Number(t.minQty)) {
      match = t;
    }
  });
  return match?.price != null ? Number(match.price) : null;
};
